/* eslint-disable react/display-name */
import React, { memo, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Handle, Position } from 'reactflow';
import EditNodeHeader from './Common/EditNodeHeader';
import { Typography, Box, Popover } from '@mui/material';
import { useJourneyStep } from '../../../../../api/Journeys/journey_queries';
import FilterReadable from 'components/FilterReadable';

const HANDLE_STYLE = {
    height: 1,
    width: 1,
    position: 'absolute',
    background: 'transparent', //'#E6F5FD',
    boxSizing: 'border-box',
    border: '2px solid transparent',
    bottom: '0px'
};

const BranchFilterEditNode = memo(({ data, isConnectable }) => {
    const { id: journeyIdStr } = useParams();
    const journeyId = parseInt(journeyIdStr);
    const { isDisabled, stepId } = data;

    const { data: step } = useJourneyStep(journeyId, stepId);

    const [popoverOpen, setPopoverOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const filterRef = useRef(null);

    const handleFilterClick = (event) => {
        setAnchorEl(event.currentTarget);
        setPopoverOpen(true);
    };

    const handlePopoverClose = () => {
        setPopoverOpen(false);
        setAnchorEl(null);
    };

    // Component to show first line with ellipsis and popover
    const FilterReadableWithPopover = ({ filterData }) => {
        if (!filterData) return null;

        return (
            <>
                <Box
                    ref={filterRef}
                    onClick={handleFilterClick}
                    sx={{
                        cursor: 'pointer',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        fontSize: '0.7rem',
                        lineHeight: 1.2,
                        padding: '1px 2px',
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            borderRadius: '2px'
                        }
                    }}
                >
                    <FilterReadable filterData={filterData} />
                </Box>
                <Popover
                    open={popoverOpen}
                    anchorEl={anchorEl}
                    onClose={handlePopoverClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    PaperProps={{
                        sx: {
                            maxWidth: 400,
                            maxHeight: 300,
                            overflow: 'auto'
                        }
                    }}
                >
                    <Box sx={{ p: 2 }}>
                        <Typography variant="subtitle2" gutterBottom>
                            Filter Details
                        </Typography>
                        <FilterReadable filterData={filterData} />
                    </Box>
                </Popover>
            </>
        );
    };

    return (
        step ?
            <div className={!isDisabled ? 'flow-branch-node' : 'flow-branch-node disabled'}>
                <Handle
                    type='target'
                    position={Position.Top}
                    style={{ left: '50%', height: 0, border: 0, background: 'transparent' }}
                    isConnectable={isConnectable}
                />

                <EditNodeHeader step={step} />
                
                {/* {step?.filter_draft?.filter_data && (
                    <EditNodeBody status={step}>
                        <FilterReadableWithPopover filterData={step.filter_draft.filter_data} />
                    </EditNodeBody>
                )} */}

                <Handle
                    type='source'
                    position={Position.Bottom}
                    id='match'
                    style={{...HANDLE_STYLE, left: '38%'}}
                    isConnectable={isConnectable}
                />
                <Handle
                    type='source'
                    position={Position.Bottom}
                    id='no_match'
                    style={{...HANDLE_STYLE, left: '60%'}}
                    isConnectable={isConnectable}
                />
            </div>
            : <></>
    );
});

export default BranchFilterEditNode;
